import React from "react";
import './styles.scss';

const Header = ({ title, heading, progressStage, reviewPage }) => {
  const reviewPageClass = (reviewPage ? 'reviewPage' : '');
  const wrapperClass = 'heading ' + reviewPageClass;

  return (
    <div className={ wrapperClass }>
      <h1 className={ reviewPageClass }>{title}</h1>
      <h2>{heading}</h2>
      {(!reviewPage && <div className='progressBar'>
        <span className='progressBarStage'
              style={(progressStage === 1 ? {width: '33%'} : (progressStage === 2 ? {width: '66%'} : {width: '100%'}))}/>
      </div>)}
    </div>
  )
};

export default Header;